import { DatePicker, Form, Input, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import { OPTIONS_ROLE } from '../../configData'
import { userSearch } from '../../services/cmsservice'
import openNotification from '../common/Notification/openNotification '
import { removeVietnameseTones } from '../../config-func'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({ form, handleSearch, listDepartment, mode }) => {
  const departments_id = Form.useWatch('departments_id', form)
  const [listUser, setListUser] = useState([])

  const onChangeDepartment = (e) => {
    form.setFieldsValue({ users_id: null })
    if (e == '') {
      getUserAll()
    } else {
      getUserAll({ department: departments_id })
    }
  }

  const getUserAll = async (values) => {
    const {
      search = '',
      role = '',
      department = '',
      status = '',
      type = '',
      page = 1,
      pageSize = 1000
    } = values || {}
    try {
      const body = { search, role, type, department, status, page, pageSize }
      const res = await userSearch(body) // Assuming roleSearch is an API function

      if (res && res.data) {
        const updatedData = res?.data?.list?.map((item) => ({
          ...item,
          label: item.name,
          value: item.id
        }))
        setListUser(updatedData) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListUser([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      setListUser([]) // Optionally, reset the list to an empty array
    } finally {
    }
  }

  useEffect(() => {
    getUserAll()
  }, [])
  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 7 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      disabled={mode == 'VIEW' ? true : false}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Tiêu đề"
        name="title"
        rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập tiêu đề" />
      </Form.Item>
      <Form.Item
        label="Nội dung"
        name="content"
        rules={[{ required: true, message: 'Vui lòng nhập nội dung' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập nội dung" />
      </Form.Item>

      <Form.Item
        label="Thời gian gửi"
        name="date_sent"
        className={styles.formItem}
        rules={[{ required: true, message: 'Vui lòng chọn thời gian gửi' }]}
      >
        <DatePicker
          style={{ width: '100%' }}
          placeholder="Chọn thời gian"
          format="HH:mm:ss DD/MM/YYYY"
          disabledDate={(current) => current && current < dayjs().endOf('day')}
        />
      </Form.Item>

      {/* <SelectField
        label="Sàn nhận"
        name="departments_id"
        options={listDepartment}
        required={true}
        hasAllOption={true}
      /> */}

      <Form.Item
        label="Sàn nhận"
        name="departments_id"
        className={styles.formItem}
        required
        rules={[
          {
            validator: (_, value) => {
              if (value === '' || value) {
                return Promise.resolve()
              }
              return Promise.reject('Vui lòng chọn sàn')
            }
          }
        ]}
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn sàn"
          onChange={onChangeDepartment}
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase()
            const optionValue = removeVietnameseTones(
              option?.children || ''
            ).toLowerCase()
            return optionValue.includes(inputValue)
          }}
          // defaultValue={""}
        >
          <Option value={''}>Tất cả</Option>
          {listDepartment?.map((item, idx) => (
            <Option key={idx} value={item.id}>
              {item.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {/* <Form.Item
        label={`Người nhận`}
        name="receiverType"
        className={styles.formItem}
        required
        rules={[
          {
            validator: (_, value) => {
              if (value === '' || value) {
                return Promise.resolve()
              }
              return Promise.reject('Vui lòng chọn sàn')
            }
          }
        ]}
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn sàn"
          onChange={onChangeReceive}
        >
          <Option value="ROLE">Theo vai trò</Option>
          <Option value="USER">Gửi riêng tư</Option>
        </Select>
      </Form.Item> */}

      <Form.Item label="Vai trò" name="permission" className={styles.formItem}>
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn vai trò"
          options={OPTIONS_ROLE}
          mode={'multiple'}
        />
      </Form.Item>

      <Form.Item label="Tài khoản" name="users_id" className={styles.formItem}>
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn tài khoản"
          // options={listUser}
          mode={'multiple'}
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase()
            const optionValue = removeVietnameseTones(
              option?.children || ''
            ).toLowerCase()
            return optionValue.includes(inputValue)
          }}
        >
          {listUser?.map((item, idx) => (
            <Option key={idx} value={item.id}>
              {item.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  )
}

export default FormPost
